"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * @Author: your name
 * @Date: 2021-12-24 15:01:27
 * @LastEditTime: 2022-02-22 10:23:05
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \sdk\bi-sdk\src\constant\chart\radar.ts
 */
exports.default = {
    default: {
        radius: "50%",
        nameGap: 1,
        center: ["50%", "50%"],
        name: {
            textStyle: {
                color: "rgba(101, 213, 255, 1)",
                fontSize: 16
            },
            formatter: function (name) {
                return name;
            }
        },
        indicator: [
            { name: "a", max: "100" },
            { name: "b", max: "100" },
            { name: "c", max: "100" },
            { name: "d", max: "100" },
            { name: "e", max: "100" },
            { name: "a", max: "100" }
        ],
        axisLine: {
            lineStyle: {
                color: "rgba(153, 209, 246, 0.2)"
            }
        },
        splitArea: {
            show: false,
            areaStyle: {
                color: "rgba(255,0,0,0)" // 图表背景的颜色
            }
        },
        splitLine: {
            show: true,
            lineStyle: {
                width: 1,
                color: "rgba(153, 209, 246, 0.2)" // 设置网格的颜色
            }
        }
    }
};
//# sourceMappingURL=radar.js.map